var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c(_vm.locked ? 'a' : 'router-link',{tag:"component",class:{ 'm-0': _vm.locked },attrs:{"to":_vm.locked ? undefined : _vm.to},on:{"click":_vm.onClick}},[_c('span',{staticClass:"icon p-0"},[_vm._t("icon")],2),_c('span',[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.locked)?_c('span',{staticClass:"mif-lock ml-1"}):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }